import { type MaybeComputedElementRef } from '@vueuse/core'
import type { SourcePageInfoData } from '~/api/interface/landing'
import { PositionKey } from '~/constants/landing'

interface Nav {
  name: string
  route?: string
  pageKey?: string
  link?: string
  children?: Nav[]
}

export const useNav = () =>
  useState<Nav[]>('nav', () => [
    {
      name: '首页',
      route: '/',
      pageKey: 'index',
    },
    {
      name: '应用场景',
      route: '/usage-scenarios',
      pageKey: 'usage-scenarios',
    },
    {
      name: '关于魔珐',
      link: 'https://www.xmov.ai',
    },
  ])

export const useSource = () => {
  const infos = useState<SourcePageInfoData>(
    'infos',
    () => ({ data: [] }) as SourcePageInfoData
  )

  const setInfos = (info: SourcePageInfoData) => {
    infos.value = info
  }

  const findComponent = (posKey: PositionKey) => {
    if (!infos.value || !infos.value.data) {
      return null
    }

    const info = infos.value.data.find(
      (item: any) => item.attributes.position.name === posKey
    )
    if (!info) {
      return null
    }
    return info.attributes
  }

  const home1OneClickGeneration = computed(() =>
    findComponent(PositionKey.Home1OneClickGeneration)
  )

  const home2HighQualityVideo = computed(() =>
    findComponent(PositionKey.Home2HighQualityVideo)
  )

  const home3VirtualHuman = computed(() =>
    findComponent(PositionKey.Home3VirtualHuman)
  )

  const home4AIGCEverything = computed(() =>
    findComponent(PositionKey.Home4AIGCEverything)
  )

  const home5AllInOne = computed(() => findComponent(PositionKey.Home5AllInOne))

  const home6EasyToUse = computed(() =>
    findComponent(PositionKey.Home6EasyToUse)
  )

  const home7TonsOfTemplates = computed(() =>
    findComponent(PositionKey.Home7TonsOfTemplates)
  )

  const home8BrandSide = computed(() =>
    findComponent(PositionKey.Home8BrandSide)
  )

  const home9StartAIGC = computed(() =>
    findComponent(PositionKey.Home9StartAIGC)
  )

  return {
    infos,
    setInfos,
    home1OneClickGeneration,
    home2HighQualityVideo,
    home3VirtualHuman,
    home4AIGCEverything,
    home5AllInOne,
    home6EasyToUse,
    home7TonsOfTemplates,
    home8BrandSide,
    home9StartAIGC,
  }
}

export const useTargetVisible = (
  target: MaybeComputedElementRef<HTMLElement>
) => {
  const isTargetVisible = ref(false)
  useIntersectionObserver(
    target,
    ([{ isIntersecting }]) => {
      // 已经显示过了就不再改变
      if (isTargetVisible.value) {
        return
      }
      isTargetVisible.value = isIntersecting
    },
    {
      threshold: 0.1,
    }
  )
  return { isTargetVisible }
}

export const useTempUserData = () => useState('tempUser', () => false)

export const useTempUser = () => {
  if (import.meta.client) {
    return ref(false)
  }
  return useTempUserData()
}
